var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-checkbox',{attrs:{"type":_vm.failed ? 'is-danger' : '',"disabled":_vm._disabled},model:{value:(_vm.checkBoxValue),callback:function ($$v) {_vm.checkBoxValue=$$v},expression:"checkBoxValue"}},[_vm._t("label",function(){return [(_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()]})],2),(_vm.failed)?_c('p',{staticClass:"text-sm text-error",class:{
      invisible: !_vm.failed,
    }},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }